import { useEffect, useState } from "react";
import { api_getLeagues } from "../axios";

/**
 * Fetches the league list (id/name/games) once for the 賽事 selector. Degrades
 * to an empty list on failure — never throws. `fetcher` is injectable for tests.
 * `refresh()` re-runs the fetch (e.g. from a retry button after a network blip).
 */
export const useLeagues = (fetcher = api_getLeagues) => {
  const [leagues, setLeagues] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [authError, setAuthError] = useState(false);
  const [reloadKey, setReloadKey] = useState(0);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    (async () => {
      try {
        const res = await fetcher();
        if (!alive) return;
        if (res && res.status && Array.isArray(res.data)) {
          setLeagues(res.data);
          setError(false);
          setAuthError(false);
        } else {
          setError(true);
          setAuthError(res?.status === false && res.message === "驗證失敗");
        }
      } catch (failure) {
        if (alive) {
          setError(true);
          setAuthError(failure?.response?.status === 401);
        }
      } finally {
        if (alive) setLoading(false);
      }
    })();
    return () => {
      alive = false;
    };
  }, [fetcher, reloadKey]);

  const refresh = () => setReloadKey((k) => k + 1);

  return { leagues, loading, error, authError, refresh };
};
